<script>
  import formatDate from '@utils/format-date'
  import ListCourse from '@components/List/Course'
  import dialogMixin from "./mixins/dialog";

  export default {
    filters: {
      formatDate,
    },
    components: {
      ListCourse,
    },
    mixins: [dialogMixin],
    props: {
      list: {
        type: Array,
        default: () => {
          return []
        },
      },
    },
    
    data() {
      return {
        isMobileSize: false,
      }
    },
    mounted() {
      const initResizeListener = () => {
        window.addEventListener('resize', this.onMobileSize)
      };

      this.onMobileSize();
      initResizeListener();
    },
    destroyed() {
      const removeResizeListener = () => {
        window.removeEventListener('resize', this.onMobileSize)
      };

      removeResizeListener();
    },
    methods: {
      onMobileSize() {
        this.isMobileSize = document.body.clientWidth <= 767
      },
    },
  }
</script>
<template>
  <el-dialog
    :visible.sync="dialogMixinDialogVisible"
    :before-close="$DialogMixinOnClose"
    :custom-class="`${ $style.dialogCoupon } isStyleLogin`"
    width="1432px"
    append-to-body
    :fullscreen="isMobileSize"
  >
    <div class="sectionTitle text-center mb-5 font-medium color-gray-7">
      適用項目
    </div>
    <template v-if="list.length > 0">
      <div class="list">
        <ListCourse
          :course-list="list"
          type="grid"
        />
      </div>
    </template>
    <template v-else>
      <BaseNull
        content="沒有適用項目"
      >
      </BaseNull>
    </template>
    <!--<pre>{{list}}</pre>-->
  </el-dialog>
</template>
<style lang="scss" module>
  .dialogCoupon {
    :global {
      .sectionTitle {
        font-size: 24px;
      }

      .courseList {

      }

    }
  }
</style>
